module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Facebook Post Insights")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.facebookPage),
      callback: function($$v) {
        _vm.facebookPage = $$v
      },
      expression: "facebookPage"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('el-option', {
      key: page.id,
      attrs: {
        "label": page.handle,
        "value": page.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Search post...",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeSearch
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.onChangeSearch
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "insights-container"
  }, [_c('loader', {
    attrs: {
      "message": "Loading Post Insights",
      "shadow": "none"
    }
  })], 1) : _c('div', _vm._l((_vm.getPostInsights), function(postInsight) {
    return _c('div', {
      key: postInsight.post_id,
      staticClass: "post-insight"
    }, [_c('div', {
      staticClass: "text-center post-content"
    }, [_vm._v(_vm._s(postInsight.message.text))]), _vm._v(" "), _c('div', {
      staticClass: "insights-container"
    }, [_c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Impression',
        "description": 'The number of times your Pages post entered a persons screen.\
                    Posts include statuses, photos, links, videos and more.',
        "value": _vm.getInsightValue(postInsight, 'impressions.total')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Engaged users',
        "description": 'The number of unique people who engaged in certain ways with your Page post,\
                    for example by commenting on, liking, sharing, or clicking upon particular elements of the post.',
        "value": _vm.getInsightValue(postInsight, 'engagements.post_engaged_users')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Engaged fans',
        "description": 'The number of people who have liked your Page and clicked anywhere in your posts.',
        "value": _vm.getInsightValue(postInsight, 'engagements.post_engaged_fan')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-insight-item', {
      attrs: {
        "title": 'Engaged clicks',
        "description": 'The number of clicks anywhere in your post on News Feed from the user that matched\
                    the audience targeting on it.',
        "value": _vm.getInsightValue(postInsight, 'engagements.post_clicks')
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "square"
    }, [_c('span', {
      staticClass: "insight-item"
    }, [_c('post-reactions', {
      staticClass: "text-center",
      attrs: {
        "reaction": postInsight.reactions
      }
    })], 1)])])])
  }), 0)]), _vm._v(" "), _c('el-pagination', {
    staticClass: "text-center paginate",
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": 1,
      "total": _vm.pages
    },
    on: {
      "current-change": _vm.onChangePage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81e0edfc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/facebook/PostOverview.vue
// module id = 3358
// module chunks = 3